module.exports = __webpack_public_path__ + "assets/img/roof-7.53d422fa.jpeg";